$(".commentary-from-president .tab-titles .tab-title").on("click", function (){
    let parent = $(this).closest(".commentary-from-president");
    let content = $(this).data("target");
    if(!$(this).hasClass("-active")) {
        parent.find(".tab-title").removeClass("-active");
        $(this).addClass("-active");
        parent.find(".tab-item").removeClass("-active");
        $(content).addClass("-active");
    }
});